import { Component, OnInit, Input } from '@angular/core';
import { TopicService } from '../topic.service';
import { GeneralComponent } from '../../General/g.component';
import { CryptoService } from '../crypto.service';
import { CryptoView } from '../crypto-view';

@Component({
  selector: 'app-polybius',
  templateUrl: './polybius.component.html',
  styleUrls: ['../topic-style.css', './polybius.component.css']
})
export class PolybiusComponent extends CryptoView {

  @Input() modus: string;
  @Input() direction: string;
  @Input() 
  set current(value: string){
      if (this.direction == "encode") {
        let currentNumber = value.charCodeAt(0) - 65;
        if (currentNumber >= 9) {
          currentNumber--;
        }
        if (currentNumber >= 20) {
          currentNumber--;
        }
        this.currentRow =  Math.floor(currentNumber / 5)
      } else {
        this.currentRow =  +value.charAt(0) - 1;
      }
    


      if (this.direction == "encode") {
        let currentNumber = value.charCodeAt(0) - 65;
        if (currentNumber >= 9) {
          currentNumber--;
        }
        if (currentNumber >= 20) {
          currentNumber--;
        }
        this.currentColumn =  currentNumber - Math.floor(currentNumber / 5) * 5;
      } else {
        this.currentColumn =  +value.charAt(1) - 1;
      }
    
  }

  currentRow: number;
  currentColumn:number;


  inputs: any[][];
  hints: string[][] = new Array(5).fill(new Array(5).fill(""));

  table: string[][] = [
    ["A", "B", "C", "D", "E"],
    ["F", "G", "H", "I/J", "K"],
    ["L", "M", "N", "O", "P"],
    ["Q", "R", "S", "T", "U/V"],
    ["W", "X", "Y", "Z", ""],

  ]

  constructor(topicService: TopicService, protected cryptoService: CryptoService) {
    super(topicService);
    this.inputs = [];
    for (let i in this.createArray(5)) {
      this.inputs.push([]);
      for (let j in this.createArray(5)) {
        this.inputs[i].push(" ");
      }
    }

  }
  /** returns the current mapping as defined by the student */
  getMapping() {
    return this.inputs.map(v => v.join(",")).join(",");
  }

  /** sets the mapping */
  setmapping(mapping: string) {
    let mappingarray = mapping.split(",");
    this.inputs = [];
    for (let i in this.createArray(5)) {
      this.inputs.push([]);
      for (let j in this.createArray(5)) {
        this.inputs[i].push(mappingarray[5 * +i + +j]);
      }
    }
  }

  /** empties the mapping */
  resetmapping(){
    this.inputs = [];
    for (let i in this.createArray(5)) {
      this.inputs.push([]);
      for (let j in this.createArray(5)) {
        this.inputs[i].push(" ");
      }
    }
  }

  /** sets the hints */
  setHints(hints: string[]) {
    for (let i of this.createArray(5)) {
      for (let j of this.createArray(5)) {
        this.hints[i][j] = hints[5 * i + j];
      }
    }
  }

  /** fills the mapping correctly */
  fillMapping() {
    this.inputs = this.table;
  }
}
